// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// Components
import OHSLoading from '../../onehivesystems/js/OHSLoading';
import OHSPopup from '../../onehivesystems/js/OHSPopup';
import OHSCRUD from '../../onehivesystems/js/OHSCRUD';
import { OHSFormDataExtractor } from '../../onehivesystems/js/OHSForm';
import { OHSCookiesSet, OHSCookiesRemove } from '../../onehivesystems/js/OHSCookies';
// Assets
import './Login.scss';
import logo from '../../onehivesystems/logos/ohs_logo_icon_gradient1.svg';


// COMPONENT
export default function Login (props) {
   // States and Variables
   const [loginLoading, setLoginLoading] = useState(false);
   const [loginPopup, setLoginPopup] = useState({
      display: false,
      title: null,
      message: null,
      severity: null,
      timespan: null
   });

   // On-Load
   useEffect(function () {
      clearAuthToken();
   }, []);

   // Functions
   const clearAuthToken = function () {
      OHSCookiesRemove('ohs_auth_token');
   }
   const handleEnterPress = function (event) {
      if (event.key === "Enter") {
         event.preventDefault();
         performLogin();
      }
   }
   const performLogin = function () {
      OHSCRUD({
         url: '/v1/onehive/login',
         method: 'POST',
         payload: OHSFormDataExtractor('login-panel'),
         success: function (data) {
            OHSCookiesSet('ohs_auth_token', data['token']);
            if (window.location.pathname != "/login") {
               window.location.href = window.location.pathname + window.location.search;
            } else {
               window.location.href = '/';
            }
         },
         setOHSLoading: setLoginLoading,
         setOHSPopup: setLoginPopup
      });
   }

   // Component
   return (
      <div className="login">
         <OHSLoading toggle={loginLoading} />
         <OHSPopup popup={loginPopup} setPopup={setLoginPopup} />
         <div id='login-panel' className='login-panel' onKeyDown={handleEnterPress}>
            <div className='login-panel-logo'>
               <img src={logo} alt="something" />
            </div>
            <div className='login-panel-title'>
               <p>Welcome to OneHive</p>
            </div>
            <div className='login-panel-username'>
               <input id='login-panel-username' type='text' className='ohsinput' placeholder='username' data-ohsformdata="username" />
            </div>
            <div className='login-panel-password'>
               <input id='login-panel-password' type='password' className='ohsinput' placeholder='password' data-ohsformdata="password" />
            </div>
            <div className='login-panel-submit'>
               <button className='ohsbtn-success' onClick={performLogin}>Log In</button>
            </div>
         </div>
      </div>
   );
}